<style lang="less" scoped>
  table{
    border-collapse:collapse;
    border: 1px solid #dddee1;
  }
  table tr{
    border-bottom: 1px solid #dddee1;
  }
  table th, table td{
    border-right: 1px solid #dddee1;
    padding: 5px 10px;
  }
  .pop-tip-text{
    display: inline-block;
    width: 100%;
    cursor: pointer;
    transition: .3s;
  }
  .pop-tip-text:hover{
    transform: translateX(-5px);
    color: #000;
  }
  .pop-tip-content{
    text-align: center;
  }
  .inner-type-1{
    color: #ff9900;
  }
</style>
<template>
  <div>
    <div class="line">
      <span>0. 普通审核</span>
      <space />
      <span class="inner-type-1">1. 采购相关审核</span>
    </div>
    <table class="">
      <thead>
        <tr>
          <th v-for="n in col_len">
            <span>{{ n }}级</span>
            <space />
            <Button
              v-if="n === 1"
              type="primary"
              size="small"
              icon="md-add"
              @click="addChildContractType()"
            >
              添加1级
            </Button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(tds, index) in contract_type_trs"
          :key="index"
        >
          <td
            v-for="td in tds"
            :key="td.id"
            :rowspan="td.rowspan"
          >
            <Poptip
              v-if="td.type_code"
              popper-class="pop-tip"
              placement="top"
              trigger="hover"
              transfer
            >
              <div
                class="pop-tip-text"
                :class="'inner-type-' + td.inner_type"
              >
                <span>[编码: {{ td.type_code }}] </span>
                <span>{{ td.name }} </span>
                <span
                  v-if="td.with_stock"
                  class="color-info"
                >
                  <Icon type="md-link" />关联存货
                </span>
                <span
                  v-if="td.need_at_audit"
                  class="color-error"
                >
                  <Icon type="md-checkbox" />分析组审核
                </span>
              </div>
              <div
                slot="content"
                class="pop-tip-content"
              >
                <Button
                  v-if="td.name"
                  size="small"
                  type="primary"
                  icon="md-create"
                  @click="editContractType(td)"
                >
                  编辑
                </Button>
                <space />
                <Button
                  v-if="td.name"
                  size="small"
                  type="primary"
                  icon="md-add"
                  @click="addChildContractType(td)"
                >
                  添加子类
                </Button>
              </div>
            </Poptip>
          </td>
        </tr>
      </tbody>
    </table>
    <Modal
      v-model="edit_contract_type_modal"
      title="添加 / 编辑 合同类型"
      :loading="edit_contract_type_loading"
      @on-ok="editOk"
    >
      <div class="line">
        <div class="line">
          <span style="margin-left: 100px" />
          <span>[ 级别: {{ edit_contract_type.level }} ] </span>
          <span>[ 父级: {{ getParentTypeName(edit_contract_type.parent_id) }} ]</span>
          <span v-if="edit_contract_type.id">[ 编码: {{ edit_contract_type.type_code }} ] </span>
        </div>
        <Form
          :model="edit_contract_type"
          :label-width="100"
        >
          <Form-item label="名称">
            <i-input
              v-model="edit_contract_type.name"
              placeholder="请输入"
            />
          </Form-item>
          <Form-item
            v-if="!edit_contract_type.id"
            label="编码"
          >
            <i-input
              v-model="edit_contract_type.type_code"
              placeholder="确定后不能更改"
            />
          </Form-item>
          <Form-item label="关联存货">
            <Checkbox v-model="edit_contract_type.with_stock" />
            设置关联后, 申请合同时要求必须录入相关的存货信息
          </Form-item>
          <Form-item label="分析组审核">
            <Checkbox v-model="edit_contract_type.need_at_audit" />
            设置后，合同需要财务分析组审核
          </Form-item>
          <Form-item label="手动提交账单">
            <Checkbox v-model="edit_contract_type.self_submit_bill" />
            合同需要手动提交账单
            <p>（如存货、版权、房租、固定资产采购类合同）</p>
          </Form-item>
          <Form-item label="审核类型">
            <Select
              v-model="edit_contract_type.inner_type"
              transfer
              placeholder="选择审核类型"
              style="width: 120px"
            >
              <Option :value="0">
                普通审核
              </Option>
              <Option :value="1">
                采购相关审核
              </Option>
            </Select>
            不同的审核类型流转到不同财务人员处审核
          </Form-item>
        </Form>
      </div>
    </Modal>
  </div>
</template>
<script route="/fin/contract_type">
  import Util from '../../libs/util';
  export default {
    /* router_info_start */
    router_info: '/fin/contract_type',
    /* router_info_end */
    data() {
      return {
        contract_types: [],
        contract_type_hash: {},
        contract_type_trs: [],
        edit_contract_type: {},
        new_contract_type: {
          name: '',
          level: 1,
          type_code: '',
          parent_id: '',
          with_stock: false,
          need_at_audit: false,
          inner_type: 0,
          self_submit_bill:false
        },
        edit_contract_type_modal: false,
        edit_contract_type_loading: true,
        fake_id: 0
      }
    },
    computed: {
      col_len() {
        let max = 0;
        this.contract_type_trs.forEach((tds) => {
          tds.forEach((td) => {
            if (td.level && td.level > max) {
              max = td.level;
            }
          });
        });
        return max;
      }
    },
    watch: {
      contract_types() {
        this.genContractHash(this.contract_types);
        this.genContractTrs();
      }
    },
    created() {
      this.getContractTypes();
    },
    mounted() {
      //
    },
    methods: {
      getContractTypes() {
        Util.ajax.get(Util.api.get_contract_types).then((response) => {
          return response.data;
        }).then((res) => {
          this.contract_types = [];
          if (res.code === 1) {
            const data = res.data;
            data.forEach((contract_type) => {
              this.contract_types.push(contract_type);
            })
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      genContractHash(contract_types) {
        contract_types.forEach((contract_type) => {
          this.contract_type_hash[contract_type.id] = contract_type;
          this.genContractHash(contract_type.contract_types);
        });
      },
      genContractTrs() {
        this.contract_type_trs = [];
        this.tr_index = 0;
        this.walkContractTypes(this.contract_types);
        this.fixEmptyTd();
      },
      walkContractTypes(contract_types) {
        contract_types.forEach((contract_type, index) => {
          contract_type.rowspan = this.getRowspan(contract_type);
          const new_contract_type = Util.clone(contract_type);
          if (index > 0) {
            this.tr_index++;
          }
          let tds = this.contract_type_trs[this.tr_index];
          if (!tds) {
            tds = [];
            this.contract_type_trs.push(tds);
          }
          tds.push(new_contract_type);
          this.walkContractTypes(contract_type.contract_types);
        });
      },
      getRowspan(contract_type) {
        if (contract_type.rowspan) {
          return contract_type.rowspan;
        }
        if (contract_type.contract_types.length === 0) {
          return 1;
        } else {
          let rowspan = 0;
          contract_type.contract_types.forEach((child_contract_type) => {
            child_contract_type.rowspan = this.getRowspan(child_contract_type);
            rowspan += child_contract_type.rowspan;
          });
          return rowspan;
        }
      },
      fixEmptyTd() {
        this.$nextTick(() => {
          this.contract_type_trs.forEach((tds) => {
            const last_td = tds[tds.length - 1];
            if (last_td.level < this.col_len) {
              for (let i = 0; i < (this.col_len - last_td.level); i++) {
                tds.push({id: `f${this.fake_id++}`, name: ''})
              }
            }
          });
        });
      },
      getParentTypeName(parent_id) {
        const parent = this.contract_type_hash[parent_id];
        if (parent) {
          return parent.name;
        } else {
          return '无';
        }
      },
      editContractType(contract_type) {
        console.log(contract_type);
        this.edit_contract_type = Util.clone(contract_type);
        this.edit_contract_type_modal = true;
      },
      addChildContractType(parent_contract_type) {
        if (parent_contract_type) {
          this.new_contract_type.parent_id = parent_contract_type.id;
          this.new_contract_type.level = parent_contract_type.level + 1;
        } else {
          this.new_contract_type.parent_id = '';
          this.new_contract_type.level = 1;
        }
        this.editContractType(this.new_contract_type);
      },
      checkValid() {
        this.edit_contract_type.name = this.edit_contract_type.name.trim();
        this.edit_contract_type.type_code = this.edit_contract_type.type_code.trim().toUpperCase();
        let msg = '';
        if (!this.edit_contract_type.name) {
          msg += '<p>[名称]不能为空</p>';
        }
        const code_reg = /^[0-9A-Z]{2}$/;
        if (!code_reg.test(this.edit_contract_type.type_code)) {
          msg += '<p>[编码]只能为两位数字/字母组合, 不区分大小写</p>';
        }
        if (msg) {
          this.edit_contract_type_loading = false;
          setTimeout(() => {
            this.edit_contract_type_loading = true;
          }, 500);
          this.$Modal.error({
            title: '提示',
            content: msg
          });
          return false;
        }
        return true;
      },
      editOk() {
        if (!this.checkValid()) {
          return;
        }
        Util.ajax.post(Util.api.update_contract_type, this.edit_contract_type).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          if (data.code === 1) {
            this.edit_contract_type_modal = false;
            this.getContractTypes();
            //Util.insertOrUpdateArrayItem(this.contract_types, data.contract_type);
            this.$Message.success({
              content: '操作成功!'
            });
          } else {
            this.edit_contract_type_loading = false;
            setTimeout(() => {
              this.edit_contract_type_loading = true;
            }, 500);
            let msg = '';
            Object.keys(data.msg).forEach((k) => {
              msg += `<p>${data.msg[k][0]}</p>`;
            });
            this.$Modal.error({
              title: '提示',
              content: '操作失败:' + msg
            });
          }
        }).catch((e) => {
          this.edit_config.loading = false;
          setTimeout(() => {
            this.edit_config.loading = true;
          }, 500);
          console.log(e);
          this.$Message.error({
            content: '操作失败!'
          });
        });
      }
    }
  }
</script>
